// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1QCvi","header":"PatientQuestionnaire_header__3S-HI","info":"PatientQuestionnaire_info__1Wx5t"};